import { isLaunchByHarmonyConnectApp } from 'system/SystemUtil';

/**
 * Check if GCW needs to apply customization for Harmony Connect App, e.g.
 *   1. Hide the page header (App would implement its native functions)
 *   2. Hide the nav sidebar (App would implement its native nav menu)
 * @param {boolean} [harmonyConnectAppFeatureEnabled]
 * @returns {boolean}
 */
export const applyHarmonyConnectCustomization = (harmonyConnectAppFeatureEnabled = false) => {
    // Cleanup ticket: CA-191687
    return harmonyConnectAppFeatureEnabled && isLaunchByHarmonyConnectApp();
};
